// The default font family used
export const FONT_FAMILY_DEFAULT = ["Arial", "Helvetica Neue", "Helvetica", "sans-serif"];
